import store from '@/store'

export default async (to, from, next) => {
  if (to.query.redirectPath) {
    next({ path: to.query.redirectPath })
  } else if ((
    from.name === 'LineOfficialAccountChoose' || from.name === 'LineOfficialAccountCreate'
  ) && store.getters['User/isActiveLineOfficialAccountEmpty']) {
    next()
  } else if (store.getters['User/hasLineOfficialAccount'] && !store.getters['User/activeBasicId']) {
    next({ name: 'LineOfficialAccountChoose' })
  } else if (!store.getters['User/activeBasicId']) {
    next({ name: 'LineOfficialAccountCreate' })
  } else {
    next()
  }
}
